import React from 'react';

const thTHA: React.FC = () => (
  <svg width='16' height='12' viewBox='0 0 16 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <rect width='16' height='12' fill='#A51931' />
    <rect y='2' width='16' height='8' fill='#F4F5F8' />
    <rect y='4' width='16' height='4' fill='#2D2A4A' />
  </svg>
);

export default thTHA;

